import React from 'react';
import { AddressType } from '../CommonTypes';
import SelectableAddress from './SelectableAddress';
import './SelectableAddresses.scss';

type SelectableAddressesProps = {
    id: string;
    addresses: AddressType[];
    selectedIndex: number;
    onSelectionChanged: (selectedIndex: number) => void;
    onEditAddressClick: (index: number) => void;
};

const SelectableAddresses = React.memo(SelectableAddressesMemo);

function SelectableAddressesMemo({
    id,
    addresses,
    selectedIndex,
    onSelectionChanged,
    onEditAddressClick
}: SelectableAddressesProps): JSX.Element {
    const onAddressClicked = (selected: boolean, index: number) => {
        const selectedIndex = selected ? index : -1;
        onSelectionChanged(selectedIndex);
    };

    const renderSelectableAddress = (address: AddressType, index: number) => {
        return (
            <SelectableAddress
                id={`${id}-${index}-address`}
                key={`${id}-${index}`}
                onClicked={(selected: boolean) => {
                    onAddressClicked(selected, index);
                }}
                onEditSelectedAddress={() => {
                    onEditAddressClick(index);
                }}
                selected={index === selectedIndex}
                style={{ border: '1px solid lightgray', marginRight: '7px' }}
                address={address}
                index={index}
            />
        );
    };

    return (
        <div id={id} className='selectableAddresses--container'>
            {addresses.map((address, index) =>
                renderSelectableAddress(address, index)
            )}
        </div>
    );
}

export default SelectableAddresses;
